// src/modules/auth/actions/getProfileAction.ts
import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { UserProfileInterface } from "../interfaces/userProfile.interface";

export async function getProfileAction(): Promise<ApiResponse<UserProfileInterface>> {
  const { data } = await apiClient.get<UserProfileInterface>("/auth/profile");
  
  return {
    status: 200,
    data,
    message: "Perfil obtenido exitosamente",
  };
}